import CRUDService from "../services/base/CRUDService";

export default class TransactionService extends CRUDService {

  getBaseURL() {
    return 'ton/v1/transactions/';
  }

  countLastWeek() {
    let date = new Date();
    date.setDate(date.getDate() - 7);
    return this.countAfterDate(date)
  }

  countAfterDate(date) {
    return this.httpRequest.get('ton/v1/transactions/count?beginDate=' + date.toISOString());
  }

  createManual(entity, checkpointId) {
    return this.httpRequest.post(`ton/v1/checkpoints/${checkpointId}/transactions`, entity);
  }

  assocMovementOrder(id, entity) {
    return this.httpRequest.put(`${this.getBaseURL()}${id}/movement-orders`, entity);
  }

  reprocess(id) {
    return this.httpRequest.put(`${this.getBaseURL()}${id}/reprocess`, {});
  }

  getTransactionItems(transactionId, productTypeId) {
    return this.httpRequest.get(`${this.getBaseURL()}items?transactionId=${transactionId}&productTypeId=${productTypeId}`)
  }

  deleteEpcByItemId(itemId, epc) {
    return this.httpRequest.delete(`ton/v1/transaction-items/${itemId}`)
  }
}



// WEBPACK FOOTER //
// ./src/transaction/TransactionService.js